import Super from './row.gjs';

export default class SpdsLayoutFlexReverseRow extends Super {
  reverse = true;
  variantClass = 'spds-layout-flex-reverse-row';
}
